import StaleDataStrip from '../../../../common/StaleDataStrip/StaleDataStrip';
import { STALE_STRIP_VARIANT } from '../../../../common/StaleDataStrip/constants';
import TalkToUsModal from '../../../../common/UnlockRefresh/TalkToUsModal';
import { useMobileStaleDataStripLogic } from './useMobileStaleDataStripLogic';

const MobileStaleDataStrip = ({ className }: { className?: string }) => {
    const { copy, isVisible, openUnlockRefresh, isTalkToUsOpen, closeTalkToUs, contactInput } = useMobileStaleDataStripLogic();

    if (!isVisible || !copy) return null;

    return (
        <div className={className}>
            <StaleDataStrip variant={STALE_STRIP_VARIANT.MOBILE} copy={copy} onOpenUnlockRefresh={openUnlockRefresh} />
            <TalkToUsModal isOpen={isTalkToUsOpen} onClose={closeTalkToUs} contactInput={contactInput} />
        </div>
    );
};

export default MobileStaleDataStrip;
